import { useCheckGPTGameStatus } from 'src/EXPERIMENTAL_LIB/api/gpt/useCheckGPTGameStatus';
import { GPTGameNameType } from '../../games/types';
import { useGPTBanner } from '../store';

export const useIsBannerVisible = (gameName: GPTGameNameType) => {
  const bannerState = useGPTBanner((state) => state[gameName]);
  const { isAvailable } = useCheckGPTGameStatus({ gameName });
  return bannerState && isAvailable;
};
